import axios from "axios";
const { BASE_URL } = require("../utils/urls");
// API URL
const API_URL=`${BASE_URL}/api`;
//const API_URL = "https://panaccoapi-453601304730.asia-south1.run.app/api";
//const API_URL = "http://localhost:8000/api";

// export const getSalesReportByCustomer = async (orgId: string, customerId: string,timeframe:string) => {
//     try {
//       const response = await axios.get(`${API_URL}/invoice/getSalesByCustomer`, {
//         params: { orgId, customerId ,timeframe},
//       });
//       return response.data; // Fixed the incorrect return value
//     } catch (error) {
//       console.error("Error fetching sales report:", error);
//       throw error;
//     }
//   };
  
export const getSalesReportByCustomer = async (orgId: string, customerId: string, timeframe: string, fromDate?: string, toDate?: string) => {
    try {
      const response = await axios.get(`${API_URL}/invoice/getSalesByCustomer`, {
        params: { orgId, customerId, timeframe, fromDate, toDate },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching sales report:", error);
      throw error;
    }
  };
  export const getSalesByItem = async (orgId: string, timeframe:string,fromDate?: string, toDate?: string) => {
    try {
      const response = await axios.get(`${API_URL}/invoice/getSalesByItem`, {
        params: { orgId,fromDate, toDate,timeframe },
      });
      return response;
    } catch (error) {
      console.error("Error fetching sales report:", error);
      throw error;
    }
  };    